import * as React from 'react';
import ReactDOM from 'react-dom';

import ABaseColumn, {IColumnDefinition, IBaseColumnProps} from './BaseColumn';
import {Column} from '../components/BasicDataGrid';
import TextFieldRegEx, {ITextFieldRegExProps} from './TextFieldRegEx';

interface ITextFieldRegExColumn extends ITextFieldRegExProps {
    /**
     * informs about the newValue is valid or not.
     *
     * @param rowData current row date before change
     * @param newValue new value
     * @param regExError "no match" or error string if not valid, undefined if valid
     */
    onCheckValid?(rowData: any, newValue: string, regExError?: "no match" | string): void;

    // disable some properties
    errorText?: undefined;
    disabled?: undefined;
    readonly?: undefined;
    underlineShow?: undefined;
    onChange?: undefined;
    onFocus?: undefined;
    onBlur?: undefined;
    id?: undefined;
}

export interface TextFieldRegExColumnPropsDefinition extends Column, ITextFieldRegExColumn {
}

interface ITextFieldRegExColumnPropsDefinition extends IColumnDefinition, ITextFieldRegExColumn {
}

interface ITextFieldRegExColumnProps extends IBaseColumnProps {
    /** information about the column, filled only in edit mode */
    column?: ITextFieldRegExColumnPropsDefinition;
}

// TODO XSVX001-200 This component is no longer used
// except in ColumnFactory, which should also be refactored
/**
 * TextFieldRegExColumn.
 * @author akirillov
 */
export default class TextFieldRegExColumn extends ABaseColumn<ITextFieldRegExColumnProps>
{
    constructor(props: ITextFieldRegExColumnProps) {
        super(props);

        this.onChangeValue = this.onChangeValue.bind(this);
    }

    onChangeValue(newValue: string, matchGroups: string[] | null, regExError?: string): void {
        const {column, rowData} = this.state;
        const col = column as ITextFieldRegExColumnPropsDefinition;
        const invalid = regExError ? regExError : matchGroups === null ? "no match" : undefined;
        if (invalid === undefined) {
            this.onChange(newValue, () => {
                if (col.onCheckValid) {
                    col.onCheckValid(rowData, newValue, invalid);
                }
            });
        }
        else if (col.onCheckValid) {
            col.onCheckValid(rowData, newValue, invalid);
        }
    }

    /**
     * custom rendering of value part
     * @param editMode rendering in edit mode or not
     */
    renderCustom(editMode: boolean) {
        const {regex = ".*"} = this.state.column;
        return (
            <TextFieldRegEx
                id={this.getId()}
                {... this.state.column}
                regex={regex}
                readonly={!editMode}
                underlineShow={editMode}
                ref={ref => {
                    if (ref) {
                        const domNode = ref.getInputNode();
                        this.setInputNode(domNode ? domNode : ReactDOM.findDOMNode(this));
                    }
                }}
                value={(this.state.value !== undefined && this.state.value !== null) ? this.state.value.toString() : JSON.stringify(this.state.value)}
                onChange={this.onChangeValue}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/TextFieldRegExColumn.tsx